import { render } from "./UpdateProfile.vue?vue&type=template&id=11ccf564&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=11ccf564&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ccf564"]])

export default __exports__